import { Language } from './language';

const en = {
    code: Language.en,

	// HOME PAGE
	t_description: '{age} years old drummer girl',
	t_close: 'Close',

	b_home: 'Home',
	b_about: 'About Me',
	b_press: 'Press',
	b_shows: 'Live Performances',
	b_soultone: 'Soultone',
	b_collision: 'Collision',
	b_language: 'English',
	b_share: 'Share',
	b_scroll_to_top: 'Scroll to top',
	b_click: 'Click',
	b_tap: 'Tap',

	t_english: 'English',
	t_spanish: 'Spanish',
	t_portuguese: 'Portuguese',
	t_italian: 'Italian',
	t_french: 'French',
	t_german: 'German',
	t_chinese: 'Chinese',

	// SHOWS PAGE

	ClassicMetal_title: 'Classic Metal',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Grand Day 2024 Performance',
	StAlsGrandDay2024_description: 'St. Alphonsus Parish School Seattle',

	BlackViolinConcert_title: 'Black Violin Concert With The World Your Orchestra',
	BlackViolinConcert_description: 'The Paramount Theatre',

	MexicanIndependenceDay2024_title: 'Mexican Independence Day Celebration With The Ballard Civic Orchestra',
	MexicanIndependenceDay2024_description: 'Town Hall Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Ballard Seafood Fest 2024',
	BallardSeaFoodFest2024_description: 'Ballard Seafood Fest',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',

	ModernMetal_title: 'Modern Metal',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Season Preview Winter 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Hair Metal',
	HairMetal_description: 'School of Rock Seattle',

	TalentShow2023_title: '2023 Talent Show',
	TalentShow2023_description: 'Seattle Salmon Bay K-8',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	SeasonPreviewSpring2023_title: 'Season Preview Spring 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'The Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Soundtrack Show',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: '90\'s Nostalgia',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: '2022 Talent Show',
	TalentShow2022_description: 'Seattle Salmon Bay K-8',


	// PRESS PAGE

	b_watch_here: 'Watch here',

	fox_13_news_title: 'Fox 13 Seattle News Featuring',
	fox_13_news_description: 'True Northwest Section Featuring',

	the_daly_migs_show_interview_title: 'The Daly Migs Show Interview',
	the_daly_migs_show_interview_description: 'Interview About Getting invited to join Godsmack on Stage',

	alizee_defan_07_02_2024_title: '"Alizee Defan" Interview',
	alizee_defan_07_02_2024_description: 'Exclusive interview',

	jaime_mendez_news_06_26_2024_title: '"Jaime Mendez News" Interview',
	jaime_mendez_news_06_26_2024_description: 'Local Seattle News in spanish',
	
	bien_informado_03_22_2023_title: '"Bien Informado" Article',
	bien_informado_03_22_2023_description: 'Argentina News Website Article about Victoria Drums',

	wave_potter_reaction_01_30_2023_title: 'Wave Potter Reaction',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter reacts to Victoria\'s cover of Lux Æterna by Metallica',

	// ABOUT PAGE

	b_back: 'Go Back',
	
	t_title: 'Victoria Acosta',
	t_pronouns: '(she/her)',

	b_read_more: 'Read more',
	b_read_less: 'Read less',

	t_about: `
With sticks in hand and rhythm in her soul, {age}-year-old Victoria Acosta is turning heads and stealing hearts as one of the most exciting young drummers to watch.

Born in El Paso, Texas, and raised in Guadalajara, Mexico, Victoria now calls Seattle home, where she continues to impress with her extraordinary dedication to her craft.

Her love for drumming began at age four, and by the time she received her first drum kit on September 13, 2018, there was no turning back. She began her formal training at Musicalerias Academy in Guadalajara and later continued her studies in Seattle, quickly advancing beyond expectations. After a standout trial lesson at the School of Rock on May 29, 2022, she bypassed the beginner program entirely and was placed in the Performers Program. Since then, Victoria has dazzled audiences in {shows} live shows with her infectious energy and commanding stage presence.

Victoria’s musical journey extends far beyond the stage. She has recorded hundreds of videos for social media, building a loyal following. On June 13, 2024, she was invited as a guest drummer for Italian composer Alberto Rigonni on the album Nemesis Call. That same year, she earned an endorsement from Soultone Cymbals on September 12, and on March 8, 2025, joined the Collision Drumsticks artist roster—further cementing her place among the next generation of elite drummers.

In addition to drums, Victoria took up the violin in 4th grade, joining the World Youth Orchestra in 2024. She shared the stage with the acclaimed duo Black Violin at the Paramount Theatre and later debuted as a percussionist with the Ballard Civic Orchestra at Town Hall Seattle for a Mexican Independence Day celebration.

Her list of accolades includes the Gold Prize and Fantastic Technique Award from the London Young Musician Contest 2022, along with the Annual Star Musician and Outstanding Drummer Special Awards in 2023.

Victoria practices daily, pushing her boundaries both as a drummer and violinist. With her unstoppable drive and boundless creativity, she’s not just a rising star—she’s a force of nature in the making.
`,

	// PRESS PAGE

	t_footer: 'All rights reserved',

	// SOULTONE: 

	b_visit_artist_page: 'Visit My Artist Page',

}

export default en;
